import { render, staticRenderFns } from "./ItemDescontoAcrescimoModal.vue?vue&type=template&id=fdb5ca42&scoped=true"
import script from "./ItemDescontoAcrescimoModal.vue?vue&type=script&lang=js"
export * from "./ItemDescontoAcrescimoModal.vue?vue&type=script&lang=js"
import style0 from "./ItemDescontoAcrescimoModal.vue?vue&type=style&index=0&id=fdb5ca42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb5ca42",
  null
  
)

export default component.exports